<span class="ml-1" *ngIf="shouldShow && menuKey && isMenuDescription && content" 
	  style="color: #ccc;"
	  ngbPopover="{{content}}" triggers="mouseenter:mouseleave">
	<i class="fa fa-info-circle"></i>
</span>

<a *ngIf="shouldShow && menuKey && !isMenuDescription && content" 
   class="btn btn-primary mr-1"
   style="padding-top: 4px; margin-top: -4px; font-weight: bold;"
   href="{{content}}" target="_blank">
	<i class="fa fa-life-saver"></i>
	Help
</a>